import React from "react";
import {styled} from "@reside/ui";
import {UserPermissionEnum} from "../../../../utils/types/user";
import {RoleNameEnum} from "../../../../utils/types/common";

import {
  CheckboxesTypes,
  DashboardsTypes,
  GeneralTypes,
  OtherTypes,
} from "../permission-management-modal/permissionTypes";
import {AdminRoles} from "../../../../atoms/admin-roles";
import {BulkPermissionsMacroCheckbox} from "./BulkPermissionsMacroCheckbox";
import {BulkQuicksightUnavailable} from "./BulkQuicksightUnavailable";
import {PermissionsBulkStatusLegend} from "./PermissionsBulkStatusLegend";

type Props = Readonly<{
  userIds: ReadonlyArray<string>;
  hasPermission: (userId: string, permission: UserPermissionEnum) => boolean;
  isPermissionPending: (permission: UserPermissionEnum) => boolean;
  onTogglePermission: (
    permission: UserPermissionEnum,
    grantToAll: boolean,
  ) => void;
  onToggleCategory: (
    permissions: ReadonlyArray<UserPermissionEnum>,
    grantToAll: boolean,
  ) => void;
}>;

export const BulkPermissionManagementForm = ({
  userIds,
  hasPermission,
  isPermissionPending,
  onTogglePermission,
  onToggleCategory,
}: Props) => (
  <>
    <PermissionsBulkStatusLegend />
    <FormGrid>
      <Column>
        <BulkPermissionsMacroCheckbox
          label="General"
          permissions={GeneralTypes}
          userIds={userIds}
          hasPermission={hasPermission}
          isPermissionPending={isPermissionPending}
          onTogglePermission={onTogglePermission}
          onToggleCategory={onToggleCategory}
        />
        <BulkPermissionsMacroCheckbox
          label="Checkboxes"
          permissions={CheckboxesTypes}
          userIds={userIds}
          hasPermission={hasPermission}
          isPermissionPending={isPermissionPending}
          onTogglePermission={onTogglePermission}
          onToggleCategory={onToggleCategory}
        />
        <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
          <BulkPermissionsMacroCheckbox
            label="Other"
            permissions={OtherTypes}
            userIds={userIds}
            hasPermission={hasPermission}
            isPermissionPending={isPermissionPending}
            onTogglePermission={onTogglePermission}
            onToggleCategory={onToggleCategory}
          />
        </AdminRoles>
      </Column>
      <Column>
        <BulkPermissionsMacroCheckbox
          label="Dashboards"
          permissions={DashboardsTypes}
          userIds={userIds}
          hasPermission={hasPermission}
          isPermissionPending={isPermissionPending}
          onTogglePermission={onTogglePermission}
          onToggleCategory={onToggleCategory}
        />
        {/* TODO(backend/permissions-management/integrations): replace with bulk Quicksight UI
            when integrations exposes bulk dashboard read/write. Grep: permissions-management */}
        <BulkQuicksightUnavailable />
      </Column>
    </FormGrid>
  </>
);

const FormGrid = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 24px;
`;

const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`;
